import { IconProps } from '@models/icons';

function Refresh({
    size, color, className, ...rest
}:IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
            className={`icon ${className}`}
            {...rest} >
            <path
                d="M17.8 9.72422C17.8 9.72422 18.8658 9.19922 15 9.19922C13.6155 9.19922 12.2622 9.60976 11.111 10.3789C9.95987 11.1481 9.06266 12.2414 8.53285 13.5204C8.00303 14.7995 7.86441 16.207 8.13451 17.5648C8.4046 18.9227 9.07129 20.17 10.0503 21.149C11.0292 22.1279 12.2765 22.7946 13.6344 23.0647C14.9922 23.3348 16.3997 23.1962 17.6788 22.6664C18.9579 22.1366 20.0511 21.2394 20.8203 20.0882C21.5895 18.9371 22 17.5837 22 16.1992"
                stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
            <path d="M15 6L18 9.5L15 13" stroke={color} strokeWidth="2" strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>
    );
}

export default Refresh;
